import { useEffect } from 'react'
import { colors } from '../../../components'
import { debug } from '../../../settings'
import { getPriceStr } from '../../../lib/utils'

export function BarChart(props) {
  const { graphData, size = {} } = props

  const canvasW = size.w || '400'
  const canvasH = size.h || '400'

  useEffect(() => {
    function start() {
      const canvas = document.getElementById('barChart')
      const ctx = canvas.getContext('2d')

      let data = graphData.map((o) => o.value)
      let labels = graphData.map((o) => o.label)

      const dataLen = data.length
      const barAreaW = Math.floor(parseInt(canvasW) / (dataLen + 0.5))      
      const barWidth = Math.floor(barAreaW / 2)
      const barSpacing = Math.floor(barAreaW / 2)

      // if(debug) {
      //   console.log('='.repeat(50), "chart info")
      //   console.log('data len  ', dataLen)
      //   console.log('barAreaW  ', barAreaW)
      //   console.log('barWidth  ', barWidth)
      //   console.log('barSpacing', barSpacing)
      // }

      
      const chartHeight = canvas.height - 50
      const maxValue = Math.floor(Math.max(...data) * 1.1)
      
      ctx.clearRect(0, 0, canvasW, canvasH)

      data.map((value, index) => {
        // bar size 계산
        const x = index * (barWidth + barSpacing) + barSpacing
        const barHeight = (value / maxValue) * chartHeight
        const y = canvas.height - barHeight - 30

        // 바 그리기
        ctx.fillStyle = colors.info // '#3498db'
        ctx.fillRect(x, y, barWidth, barHeight)

        // 라벨 그리기
        ctx.fillStyle = colors.dark
        ctx.font = '0.8rem sans-serif'
        ctx.textAlign = 'center'
        ctx.fillText(labels[index], x + barWidth / 2, canvas.height - 10)

        // 값 표시
        ctx.fillStyle = colors.danger
        ctx.fillText( getPriceStr(value), x + barWidth / 2, y - 5)
      })
    }
    start()
  }, [graphData])

  const styles = {
    canvasWrap: {
      width: '100%',
      display: 'flex',
      justityContent: 'center',
    },
    canvas: {
      border: '1px solid #ccc',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  }

  return (
    <div style={styles.canvasWrap}>
      <canvas
        style={styles.canvas}
        id="barChart"
        width={canvasW}
        height={canvasH}
      ></canvas>
    </div>
  )
}
